import { Telemetry } from '@amzn/ihm-telemetry-js-lib';
import { Operation, Persistence } from '../persistence';
import { Event } from './_event';
import { Task } from './task';

export class Workflow extends Event {
    private taskIds: string[];

    protected save() {
        Persistence.save(Operation.WORKFLOW, this._id, this.toJSON());
    }

    protected setCurrent() {
        // Only ATBase may do this?
        // Persistence._setCurrent(Operation.WORKFLOW, this._id);
    }

    protected delete() {
        Persistence.delete(Operation.WORKFLOW, this._id);
    }

    protected hydrate(data: any) {
        super.hydrate(data);
        this.taskIds = data.taskIds || [];
    }

    private getChildren() {
        const tasks = Persistence.getAll(Operation.TASK);
        return this.taskIds.map((id) => Task.fromJSON(tasks[id])).filter(Boolean);
    }

    public constructor(name: string, save: boolean = true) {
        super(name);
        this.taskIds = [];
        if (save) this.save();
    }

    public static fromJSON(data: any) {
        if (!data) return null;
        const workflow = new Workflow(data.name);
        workflow.hydrate(data);
        workflow.save();
        return workflow;
    }

    public toJSON() {
        return {
            ...super.toJSON(),
            taskIds: this.taskIds,
        };
    }

    public start() {
        try {
            super.start();
            this.save();
            console.info('[Telemetry] Workflow started successfully with the name:' + this.name + ', id: ' + this._id);
        } catch (error) {
            console.error('Error starting workflow:', error);
        }
    }

    public stop(aborted: boolean = false) {
        try {
            this.getChildren().forEach((task) => task.stop(true));
            if (!this.startTime || this.completed) return;
            super.stop(aborted);
            this.save();
            const data = Event.getPayload(Persistence.getById(Operation.WORKFLOW, this._id));
            if (data) {
                Telemetry.emit('process.workflow', data);
            }
            console.info('[Telemetry] Workflow stopped successfully with the name:' + this.name + ', id: ' + this._id);
            this.delete();
        } catch (error) {
            console.error('Error stopping workflow:', error);
        }
    }

    public addTask(name: string) {
        const task = new Task(name);
        this.taskIds.push(task.id);
        this.save();
        return task;
    }
}
